/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
    ScheduleReference,
    ScheduleReferenceFromJSON,
    ScheduleReferenceFromJSONTyped,
    ScheduleReferenceToJSON,
    SubtaskReference,
    SubtaskReferenceFromJSON,
    SubtaskReferenceFromJSONTyped,
    SubtaskReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobReference
 */
export interface JobReference {
    /**
     * 
     * @type {number}
     * @memberof JobReference
     */
    id: number;
    /**
     * 
     * @type {Array<SubtaskReference>}
     * @memberof JobReference
     */
    readonly subtasks?: Array<SubtaskReference>;
    /**
     * 
     * @type {Array<ScheduleReference>}
     * @memberof JobReference
     */
    readonly schedules?: Array<ScheduleReference>;
    /**
     * 
     * @type {Array<ElementsUserReference>}
     * @memberof JobReference
     */
    readonly allowUsers?: Array<ElementsUserReference>;
    /**
     * 
     * @type {Array<ElementsGroupReference>}
     * @memberof JobReference
     */
    readonly allowGroups?: Array<ElementsGroupReference>;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly startable?: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof JobReference
     */
    readonly variableDefinitions?: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobReference
     */
    readonly mediaRoots?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly webhookUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobReference
     */
    readonly specialType?: JobReferenceSpecialTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly allowOthersToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly allowClientToStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly showAsButton?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly inputType?: JobReferenceInputTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobReference
     */
    readonly addToNewMediaRoots?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly hook?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobReference
     */
    readonly webhookSecret?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobReference
     */
    readonly securityContext?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobReference
     */
    readonly partOfWorkflowFor?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum JobReferenceSpecialTypeEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3
}/**
* @export
* @enum {string}
*/
export enum JobReferenceInputTypeEnum {
    Path = 'path',
    Dir = 'dir',
    Paths = 'paths',
    Dirs = 'dirs'
}

export function JobReferenceFromJSON(json: any): JobReference {
    return JobReferenceFromJSONTyped(json, false);
}

export function JobReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subtasks': !exists(json, 'subtasks') ? undefined : ((json['subtasks'] as Array<any>).map(SubtaskReferenceFromJSON)),
        'schedules': !exists(json, 'schedules') ? undefined : ((json['schedules'] as Array<any>).map(ScheduleReferenceFromJSON)),
        'allowUsers': !exists(json, 'allow_users') ? undefined : ((json['allow_users'] as Array<any>).map(ElementsUserReferenceFromJSON)),
        'allowGroups': !exists(json, 'allow_groups') ? undefined : ((json['allow_groups'] as Array<any>).map(ElementsGroupReferenceFromJSON)),
        'startable': !exists(json, 'startable') ? undefined : json['startable'],
        'variableDefinitions': !exists(json, 'variable_definitions') ? undefined : json['variable_definitions'],
        'mediaRoots': !exists(json, 'media_roots') ? undefined : json['media_roots'],
        'webhookUrl': !exists(json, 'webhook_url') ? undefined : json['webhook_url'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'allowOthersToStart': !exists(json, 'allow_others_to_start') ? undefined : json['allow_others_to_start'],
        'allowClientToStart': !exists(json, 'allow_client_to_start') ? undefined : json['allow_client_to_start'],
        'showAsButton': !exists(json, 'show_as_button') ? undefined : json['show_as_button'],
        'inputType': !exists(json, 'input_type') ? undefined : json['input_type'],
        'addToNewMediaRoots': !exists(json, 'add_to_new_media_roots') ? undefined : json['add_to_new_media_roots'],
        'hook': !exists(json, 'hook') ? undefined : json['hook'],
        'webhookSecret': !exists(json, 'webhook_secret') ? undefined : json['webhook_secret'],
        'securityContext': !exists(json, 'security_context') ? undefined : json['security_context'],
        'partOfWorkflowFor': !exists(json, 'part_of_workflow_for') ? undefined : json['part_of_workflow_for'],
    };
}

export function JobReferenceToJSON(value?: JobReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


